import { Injectable } from '@angular/core';
import { BlOauthClient } from '@bl/bl-auth/dist/bl-oauth-client';
import { LoginEndResponse, UserInfoResponse } from '@bl/bl-auth/dist/types';
import { BehaviorSubject, from, Observable, switchMap, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SsoAuthService {
  private blOauthClient: BlOauthClient;
  // private authStateSubject = new BehaviorSubject<string | null | undefined>(null);
  private csrfTokenSubject = new BehaviorSubject<string | null>(null);

  get csrfToken() {
    return this.csrfTokenSubject.asObservable();
  }

  // get authState() {
  //   return this.authStateSubject.asObservable();
  // }

  constructor() {
    this.blOauthClient = new BlOauthClient({
      baseUrl: environment.blauth.ssoOauthAgentUrl,
      cookieNamePrefix: environment.blauth.cookieNamePrefix,
    });
  }

  loginStart() {
    return from(this.blOauthClient.loginStart());
  }

  loginEnd() {
    return from(this.blOauthClient.loginEnd(window.location.href)).pipe(tap(({ csrf }) => this.updateCsrfToken(csrf)));
  }

  getCsrfToken() {
    return this.csrfTokenSubject.getValue();
  }

  async getOAuthLoginStatus(): Promise<LoginEndResponse> {
    const response = await this.blOauthClient.loginEnd(window.location.href);
    this.updateCsrfToken(response.csrf);

    return response;
  }

  refreshToken(): Observable<LoginEndResponse> {
    return from(this.blOauthClient.refreshToken()).pipe(switchMap(() => this.getOAuthLoginStatus()));
  }

  getCurityUserInfo(): Observable<UserInfoResponse> {
    return from(this.blOauthClient.userInfo());
  }

  // updateAuthState(state: string | null | undefined) {
  //   this.authStateSubject.next(state);
  // }

  private updateCsrfToken(token: string | null) {
    if (token && token !== '') {
      this.csrfTokenSubject.next(token);
    }
  }
}
